import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ContextMenuItemComponent } from '@frontendlib/components/features/popover/components/context-menu-item/context-menu-item.component';
import { type FormsView, type FormsWorkspaceStore } from '../../services/forms-workspace.store';

export type FormsPanelNavigation = FormsView | 'folders';

export interface FormsPickerView { readonly id: Exclude<FormsView, 'search_results'>; readonly title: string }

@Component({
  selector: 'app-forms-views-context-menu',
  templateUrl: './forms-views-context-menu.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ContextMenuItemComponent],
})
export class FormsViewsContextMenuComponent {
  /** Set by the opening directive on the created instance before first render (`ContextMenuDirective` assigns
   * component fields directly, so this cannot be a signal input). */
  public listStore: FormsWorkspaceStore;

  public foldersOpen = false;
  public hasSearchResults = false;
  public views: readonly FormsPickerView[] = [];
  public navigate?: (view: FormsPanelNavigation) => void;

  protected select(view: FormsPanelNavigation): void {
    if (this.navigate) { this.navigate(view); return; }
    if (view === 'folders') return;
    if (view === 'search_results') this.listStore.landOnSearchResults();
    else void this.listStore.selectView(view);
  }
}
